"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var _createClass2 = _interopRequireDefault(require("reshow-runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("reshow-runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("reshow-runtime/helpers/defineProperty"));
var _react = require("react");
var _reactAtomicAtom = require("react-atomic-atom");
var _getObjectValue = _interopRequireDefault(require("get-object-value"));
var _reshowConstant = require("reshow-constant");
var _injectStyle = _interopRequireDefault(require("../../lib/styles/injectStyle.js"));
var _bindStyles = _interopRequireDefault(require("../../lib/styles/bindStyles.js"));
var _getChildMapping = require("../../getChildMapping.js");
var _useCSS = _interopRequireDefault(require("../../hooks/useCSS.js"));
var _excluded = ["ui", "renderChildren", "atoms", "useCSS", "cssList", "refCb", "atom", "children", "styles", "styleOrder"]; // @ts-check
/**
 * @param {boolean} render
 * @param {import("react").ReactNode} children
 * @returns {React.ReactNode}
 */
var getChildren = function getChildren(render, children) {
  return render && children != null ? (0, _getChildMapping.bindChildKey)(children) : null;
};
var CSSType = /*#__PURE__*/(0, _createClass2["default"])(function CSSType() {
  (0, _classCallCheck2["default"])(this, CSSType);
  /**
   * @type string[]
   */
  (0, _defineProperty2["default"])(this, "cssModule", void 0);
  /**
   * @type string
   */
  (0, _defineProperty2["default"])(this, "cssGroup", void 0);
});
/**
 * @typedef {object} SemanticUIProps
 * @property {boolean=} ui
 * @property {boolean=} renderChildren
 * @property {Object<any, React.ReactNode>=} atoms
 * @property {string=} atom
 * @property {function=} useCSS
 * @property {CSSType[]=} cssList
 * @property {function=} refCb
 * @property {React.ReactNode=} children
 * @property {Object=} styles
 * @property {number=} styleOrder
 * @property {string=} className
 * @property {React.CSSProperties=} style
 * @property {React.RefObject|function=} ref
 */
/**
 * @param {SemanticUIProps&React.HTMLProps} props
 * @returns {React.ReactElement | null}
 */
var SemanticUI = function SemanticUI(_ref) {
  var _ref$ui = _ref.ui,
    ui = _ref$ui === void 0 ? true : _ref$ui,
    _ref$renderChildren = _ref.renderChildren,
    renderChildren = _ref$renderChildren === void 0 ? true : _ref$renderChildren,
    _ref$atoms = _ref.atoms,
    atoms = _ref$atoms === void 0 ? _reactAtomicAtom.html : _ref$atoms,
    _ref$useCSS = _ref.useCSS,
    useCSS = _ref$useCSS === void 0 ? _useCSS["default"] : _ref$useCSS,
    _ref$cssList = _ref.cssList,
    cssList = _ref$cssList === void 0 ? [] : _ref$cssList,
    refCb = _ref.refCb,
    atom = _ref.atom,
    children = _ref.children,
    styles = _ref.styles,
    styleOrder = _ref.styleOrder,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  /**
   * @type string
   */
  var nextAtom = null != atom ? atom : atoms["default"];
  switch (atom) {
    case "null":
      return null;
    default:
      var componentData = (0, _getObjectValue["default"])(atoms, [atom]);
      if (componentData) {
        if ((0, _reshowConstant.HAS)(componentData, "renderChildren")) {
          renderChildren = componentData.renderChildren;
        }
        if ((0, _reshowConstant.HAS)(componentData, "ui")) {
          renderChildren = componentData.ui;
        }
      }
      break;
  }
  if (styles) {
    var className = restProps.className,
      style = restProps.style;
    // Need avoid props pass by ref !!important!!
    (0, _injectStyle["default"])();
    // bindStyles need after inject
    var bindProps = (0, _bindStyles["default"])({
      /** @type any*/className: className,
      style: style,
      styles: styles,
      styleOrder: styleOrder
    });
    (0, _reshowConstant.KEYS)(bindProps).forEach(function (key) {
      return restProps[key] = bindProps[key];
    });
  }
  if (ui) {
    cssList.forEach(function (_ref2) {
      var cssModule = _ref2.cssModule,
        cssGroup = _ref2.cssGroup;
      return useCSS(cssModule, cssGroup);
    });
    /**
     * Need put after bindProps
     *!!important!! restProps.className maybe effect by bindProps, so use it here.
     */
    restProps.className = restProps.className ? restProps.className + " ui" : "ui";
  }
  if (refCb) {
    restProps.ref = /**@type any*/refCb;
  }
  return /*#__PURE__*/(0, _react.createElement)(nextAtom, restProps, getChildren(renderChildren, children));
};
var _default = exports["default"] = SemanticUI;
module.exports = exports.default;